import React, { useCallback, useEffect, type FC } from 'react'

import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue } from 'recoil'

import styled from '@emotion/styled'

import useAsyncTask from 'Hooks/useAsyncTask'

import {
  BUTTON_VARIANT_PRIMARY,
  Button,
  MODAL_SIZE_MD,
  Modal,
  ModalBody,
  ModalFoot,
  ModalHead,
  Spinner,
  TEXT_VARIANT_BOLD,
  Text,
} from 'mailup-web-components'

import { modalSimulateCancelCallback } from 'Pages/UnsubscriptionCampaignsList/recoil/callbacks/modals'
import { modalSimulateState } from 'Pages/UnsubscriptionCampaignsList/recoil/state/modals'
import {
  extractSimulateResult,
  simulateWorkflow,
} from 'Pages/UnsubscriptionCampaignsList/services/modals'

const StyledSpinner = styled(Spinner)`
  margin: 0 4px;
`
const StyledData = styled.span`
  margin-left: 4px;
`

const ModalSimulate: FC = () => {
  const intl = useIntl()

  const { idWorkflow, show } = useRecoilValue(modalSimulateState)

  const handleCancel = useRecoilCallback(modalSimulateCancelCallback, [])

  const launchTask = useCallback(async () => {
    return await simulateWorkflow(idWorkflow)
  }, [idWorkflow])

  const { metadata, init, cleanup } = useAsyncTask({
    launchTask,
  })

  const { totalCount, discarded } = extractSimulateResult(metadata)

  useEffect(() => {
    if (show) {
      void init()
    }

    return () => {
      if (show) {
        void cleanup()
      }
    }
  }, [show])

  return (
    <Modal
      data-mu-test="modal-simulate-confirm"
      show={show}
      showClose
      onClose={handleCancel}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.ModalSimulates.Title',
        })}
      />

      <ModalBody>
        {intl.formatMessage({
          id: 'Load.ModalSimulates.ResultPositiveFirstNew',
        })}
        <Text variant={TEXT_VARIANT_BOLD} htmlElement="span">
          {totalCount !== undefined && <StyledData>{totalCount} </StyledData>}
          {totalCount === undefined && <StyledSpinner />}
          {intl.formatMessage({
            id: 'Load.ModalSimulates.Contacts',
          })}
          {discarded !== undefined && <StyledData>{discarded} </StyledData>}
          {discarded === undefined && <StyledSpinner />}
          {intl.formatMessage({
            id: 'Load.ModalSimulates.DiscardedContactsNew',
          })}
        </Text>{' '}
        {intl.formatMessage({
          id: 'Load.ModalSimulates.ResultPositiveFirstDetail',
        })}
      </ModalBody>
      <ModalFoot>
        <Button
          kind={BUTTON_VARIANT_PRIMARY}
          onClick={handleCancel}
          data-mu-test="button-confirm"
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.Ok' })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

export default ModalSimulate
